import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthenticateDomainService } from 'src/app/private/services/authenticate-domain.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-add-auth-domain',
  templateUrl: './add-auth-domain.component.html',
  styleUrls: ['./add-auth-domain.component.scss']
})
export class AddAuthDomainComponent {
  domain: string = '';
  spf: any = null;
  dkim: any[] = [];
  isAddDomain: boolean = true;
  isShowDetails: boolean = false;
  btnLoading: boolean = false;
  isShowEditDetails: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() domainCreated = new EventEmitter<void>();

  @Input() type : 'Add' | 'View' = 'Add'; // Default to 'Add'
  @Input() domainData: any; // Used when type is 'View'

  constructor(
    private domainAuthService: AuthenticateDomainService,
    private localStorage: LocalStorageService,
    private toastr: ToastrService,
    private tracker: TrackingService,
  ) {
  }

  ngOnInit() {
    console.log('AddAuthDomainComponent initialized with type:', this.type);
    console.log('Domain data:', this.domainData);
    if (this.type == 'View') {
      this.initDomainAuth(this.domainData);
      // this.dkim = this.domainData.dkim_tokens || [];
      // this.domain = this.domainData.domain || '';
      // this.spf = this.domainData.spf_token || null;
      // this.isAddDomain = false;
      // this.isShowDetails = false;
      // this.isShowEditDetails = true; // Show edit details when viewing

    }
  }


  /**
   * Maps authenticateClientDomain API ({ spf, dkim }) or DB row ({ spf_token, dkim_tokens }) into template fields.
   */
  initDomainAuth(response: any) {
    if (!response) {
      return;
    }
    const payload =
      response && typeof response === 'object' && 'data' in response && response.data != null
        ? response.data
        : response;

    this.domain = payload.domain ?? '';
    this.spf = payload.spf ?? payload.spf_token ?? null;
    const dkimRaw = payload.dkim ?? payload.dkim_tokens;
    this.dkim = Array.isArray(dkimRaw) ? dkimRaw : [];

    this.isAddDomain = false;
    this.isShowDetails = true;
  }

  private extractErrorMessage(error: HttpErrorResponse): string {
    const body = error.error;
    if (body == null) {
      return 'Failed to initiate domain authentication. Please try again.';
    }
    if (typeof body === 'string') {
      return body;
    }
    if (typeof body === 'object') {
      if (typeof body.message === 'string') {
        return body.message;
      }
      if (typeof body.error === 'string') {
        return body.error;
      }
    }
    return 'Failed to initiate domain authentication. Please try again.';
  }

  copyToClipboard(value: string) {
    const text = value != null ? String(value) : '';
    navigator.clipboard.writeText(text).catch(() => {});
  }
  submitDomainAuth() {

    const payload = {
      client_id: this.localStorage.getClientId(),
      domain: this.domain,
    }

    this.btnLoading = true;
    this.domainAuthService.authenticateClientDomain(payload).subscribe({
      next: (response) => {
        this.btnLoading = false;
        this.initDomainAuth(response);
        this.domainCreated.emit();
        this.toastr.success('Domain authentication initiated successfully.');
        const desc = `Authentication initiated for domain: ${this.domain}`;
        this.tracker.track('Create', 'Domain Authentication', desc);
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error during domain authentication:', error);
        this.btnLoading = false;
        const msg = this.extractErrorMessage(error);
        const title = error.status === 409 ? 'Domain already registered' : 'Domain authentication failed';
        this.toastr.error(msg, title);
      },
    });

  }

  closeModal() {
    this.close.emit();
  }
}
